<template>
  <div>
    <p class="desc-info">
      <span>订单号：{{ this.flowInfo.orderId }}</span>
      <span>
        任务类型：{{
          flowInfo.flowLevel == 3
            ? 'PE'
            : flowInfo.flowLevel == 4
            ? '审核'
            : 'PE&审核'
        }}
      </span>
      <span>
        当前任务状态：{{
          flowInfo.status === -2
            ? '进行中'
            : this.$flowStatus.get(flowInfo.status)
        }}
      </span>
      <span>语种方向：{{ $sysLan.get(slan) }}-{{ $sysLan.get(tlan) }}</span>
      <el-button
        type="primary"
        icon="el-icon-document"
        size="mini"
        class="m-r-10"
        @click="toOrderDetail"
        plain
      >
        订单详情
      </el-button>
      <el-button
        size="mini"
        type="warning"
        v-if="
          (this.flowInfo.status === 3 || this.flowInfo.status === -2) &&
          permissions.dot_flow_submit
        "
        @click.stop="endMission()"
      >
        结束{{
          flowInfo.flowLevel == 3
            ? 'PE'
            : flowInfo.flowLevel == 4
            ? '审核'
            : 'PE&审核'
        }}任务
      </el-button>
    </p>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="tabName + '配置'" name="1">
        <peConfigure
          v-if="flowInfo.flowLevel && slan"
          :configInfo="this.configInfo"
          :pePrice="this.configInfo.pePrice"
          :flowLevel="flowInfo.flowLevel"
          :orderId="this.flowInfo.orderId"
          :orderTag="orderTag"
          :slan="slan"
          :tlan="tlan"
          :staParams="staParams"
          ref="peConfigure"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="
          this.flowInfo.status === 3 ||
          this.flowInfo.status === 4 ||
          this.flowInfo.status === -2
        "
        label="数据统计"
        name="2"
      >
        <peStatistics
          v-if="flowInfo.flowLevel"
          :flowLevel="flowInfo.flowLevel"
          :orderId="flowInfo.orderId"
          :orderTag="orderTag"
          :isMtOut="isMtOut"
          :staParams="staParams"
          ref="peStatistics"
        ></peStatistics>
      </el-tab-pane>
      <el-tab-pane
        v-if="
          this.flowInfo.status === 3 ||
          this.flowInfo.status === 4 ||
          this.flowInfo.status === -2
        "
        label="任务管理"
        name="3"
      >
        <peManage
          v-bind:flowInfo="this.flowInfo"
          :staParams="staParams"
          ref="peManage"
        ></peManage>
      </el-tab-pane>
      <el-tab-pane
        v-if="this.flowInfo.status === 4"
        :label="tabName + '终稿'"
        name="4"
      >
        <el-row>
          <el-col offset="1">
            <el-radio-group v-model="tranFromat">
              <el-radio label="1">纯译文</el-radio>
              <el-radio label="2">段段对照</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <fileDown
              :fileOption="{ title: '终稿-未翻/通过部分为原文' }"
              v-if="this.flowInfo.orderId && slan"
              :taskType="4"
              :type="4"
              :orderId="this.flowInfo.orderId"
              :tranFromat="tranFromat"
              :staParams="staParams"
              key="peDown"
              ref="peDown"
            />
          </el-col>
          <el-col :span="24" v-if="showPeTranDown">
            <fileDown
              :fileOption="{
                title:
                  '终稿-未翻部分为译文（未审核的还原为最后一次PE结果，未PE的还原为机翻译文）',
              }"
              v-if="this.flowInfo.orderId && slan"
              :type="12"
              :taskType="4"
              :orderId="this.flowInfo.orderId"
              :tranFromat="tranFromat"
              :staParams="staParams"
              key="peTranDown"
              ref="peTranDown"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane v-if="this.flowInfo.status === 4" label="平行语料" name="5">
        <el-row>
          <el-col :span="24">
            <fileDown
              :fileOption="{ title: '平行语料稿-未翻/通过部分为原文' }"
              v-if="this.flowInfo.orderId"
              :type="5"
              :taskType="4"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams"
              key="peExcelDown"
              ref="peExcelDown"
            />
          </el-col>
          <el-col :span="24" v-if="showPeTranDown">
            <fileDown
              :fileOption="{ title: '平行语料稿-未翻/通过部分为译文' }"
              v-if="this.flowInfo.orderId"
              :type="18"
              :taskType="4"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams"
              key="peTranDown2"
              ref="peTranDown2"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="活动配置" name="6">
        <event-data
          ref="eventData"
          :appScope="1"
          :orderId="flowInfo.orderId"
          :staParams="staParams"
        ></event-data>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import eventData from '@/views/events/eventData';
import peConfigure from './pe-configure';
import peStatistics from './pe-statistics';
import peManage from './pe-manage';
import peFinal from './pe-final';
import { getFlowInfo, getByType, statistics } from '@/api/dot/flow';
import { getObj } from '@/api/dot/order';
import { check, finish } from '@/api/dot/pe';
import { mapGetters, mapState } from 'vuex';
import { alertErroMsg, alertSuccessMsg, alertCommon } from '@/util/commonMsg';
import fileDown from '@/views/common/fileDown';
export default {
  components: {
    peConfigure,
    peStatistics,
    peManage,
    peFinal,
    fileDown,
    eventData,
  },
  data() {
    return {
      tranFromat: '1',
      activeName: '1',
      flowInfo: {},
      configInfo: {},
      page: false,
      slan: '',
      tlan: '',
      showPeTranDown: false,
      data: [],
      orderTag: null,
      staParams: null,
      tabName: '',
    };
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  watch: {
    $route(to, from) {
      this.getFlowInfo();
    },
  },
  created: function () {
    this.getFlowInfo();
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: this.curPath,
      ref_url: this.oldPath,
      scene_name: 'PE任务详情',
    };
  },
  mounted() {
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
          },
          this.staParams,
        ),
      );
    },

    // 获取流程信息
    getFlowInfo() {
      this.flowInfo = {};
      this.configInfo = {};
      getFlowInfo(this.$route.params.id).then((response) => {
        this.flowInfo = response.data.data;
        if (response.data.data.flowLevel == 3) {
          this.tabName = 'PE';
        }
        if (response.data.data.flowLevel == 4) {
          this.tabName = '审核';
        }
        if (response.data.data.flowLevel == 5) {
          this.tabName = 'PE&审核';
        }
        getObj(this.flowInfo.orderId).then((res) => {
          this.slan = res.data?.data?.slan;
          this.tlan = res.data?.data?.tlan;
          this.orderTag = res.data?.data?.orderTag;
          this.isMtOut = res.data?.data?.isMtOut;
          this.tranFromat = res.data.data.tranFormat + '';
        });

        let tempConfig = {};
        if (this.flowInfo.configInfo) {
          tempConfig = JSON.parse(this.flowInfo.configInfo);

          console.log('111', tempConfig, tempConfig.pePrice);
          tempConfig.peAuditPackageType = tempConfig.peAuditPackageType
            ? tempConfig.peAuditPackageType
            : 2;
          tempConfig.limitTime = this.flowInfo.limitTime;
          tempConfig.remark = this.flowInfo.remark;
          tempConfig.pePrice = JSON.parse(this.flowInfo.configInfo).pePrice;
        } else {
          tempConfig.peAuditPackageType = 2;
        }

        if (
          this.flowInfo.status === 1 &&
          (this.flowInfo.remark == null || this.flowInfo.remark == '')
        ) {
          tempConfig.remark =
            '1. 为使术语统一，页面上可能会有相应的术语提示，请按规定使用术语判断译文结果；\n' +
            '2. 缩写不翻译（例如PID，EMI不翻译）；\n' +
            '3. 厂商品牌名称不翻译（例如ABB不翻译）；\n' +
            '4. 公制单位不翻译（例如kg,kw不翻译）；\n' +
            '5. 注意低错问题（数字，漏译，标点符号）；\n' +
            '6. 不确定的单词请通过字典或在网上查验；';
        }
        if (
          this.flowInfo.status === 1 &&
          this.flowInfo.remark != null &&
          this.flowInfo.remark != ''
        ) {
          tempConfig.remark = this.flowInfo.remark;
        }

        tempConfig.orderId = this.flowInfo.orderId;
        tempConfig.status = this.flowInfo.status;
        tempConfig.isConfigDisabled = this.flowInfo.status !== 1;
        tempConfig.isRemarkDisabled =
          this.flowInfo.status === 4 || this.flowInfo.status === -1;
        this.configInfo = tempConfig;
        getByType({ orderId: this.flowInfo.orderId, type: 6 }).then((res) => {
          //有质控并且状态是-1已取消，展示
          if (
            res.data.data == null ||
            (res.data.data && res.data.data.status === -1)
          ) {
            this.showPeTranDown = true;
          } else {
            this.showPeTranDown = false;
          }
        });
      });
    },

    toOrderDetail() {
      this.$router.push({ path: '/dot/order/detail/' + this.flowInfo.orderId });
      statistics(
        Object.assign(
          {
            event_name: '订单详情',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    btnReturnFail(msg) {
      this.$message.error({
        message: msg,
        duration: 1500,
        onClose: () => {
          this.$router.replace({
            path: '/refresh',
          });
        },
      });
    },
    handleClick(tab, event) {
      if (tab.name === '2') {
        this.$refs.peStatistics.init();
      } else if (tab.name === '3') {
        this.$refs.peManage.getPage(
          this.$refs.peManage.page,
          this.$refs.peManage.searchForm,
        );
      } else if (tab.name === '4') {
        this.$refs.peDown.init();
        if (this.showPeTranDown) {
          this.$refs.peTranDown.init();
        }
        this.$refs.peExcelDown.init();
      } else if (tab.name === '5') {
        this.$refs.peExcelDown.init();
        this.$refs.peTranDown2.init();
      } else if (tab.name === '6') {
        //todo 活动配置
        this.$refs.eventData.init();
      }
    },
    endMission() {
      check(this.$route.params.id).then((res) => {
        if (res.data.data <= 0) {
          this.btnReturnFail('提交失败');
        } else {
          let msg;
          switch (res.data.data) {
            case 1:
              msg = '是否立刻结束任务？';
              break;
            case 2:
              msg = `【温馨提示：确定您已与质控核实质控任务已完成？若质控未完成结束${
                this.flowInfo.flowLevel == 3
                  ? 'PE'
                  : this.flowInfo.flowLevel == 4
                  ? '审核'
                  : 'PE&审核'
              }，将造成质控风险。${
                this.flowInfo.flowLevel == 3
                  ? 'PE'
                  : this.flowInfo.flowLevel == 4
                  ? '审核'
                  : 'PE&审核'
              }任务尚未结束，确定结束${
                this.flowInfo.flowLevel == 3
                  ? 'PE'
                  : this.flowInfo.flowLevel == 4
                  ? '审核'
                  : 'PE&审核'
              }，剩余任务将会由质控处理。】`;
              break;
            case 3:
              msg = `【温馨提示：${
                this.flowInfo.flowLevel == 3
                  ? 'PE'
                  : this.flowInfo.flowLevel == 4
                  ? '审核'
                  : 'PE&审核'
              }任务尚未结束，确定结束${
                this.flowInfo.flowLevel == 3
                  ? 'PE'
                  : this.flowInfo.flowLevel == 4
                  ? '审核'
                  : 'PE&审核'
              }，剩余任务将会由质控处理。】`;
              break;
            case 4:
              msg = `【温馨提示：质控老师尚未领单，此时结束${
                this.flowInfo.flowLevel == 3
                  ? 'PE'
                  : this.flowInfo.flowLevel == 4
                  ? '审核'
                  : 'PE&审核'
              }任务，将无法进行质控任务。】`;
              break;
          }
          this.alertFinish(msg);
        }
      });
    },
    finishPe() {
      finish(this.$route.params.id, this.flowInfo.orderId).then((res) => {
        alertCommon(res.data.data);
      });
      statistics(
        Object.assign(
          {
            event_type: 'click',
            event_name: '结束打标任务',
            class_name: 'finish',
            class_url: '/dotadmin/dotadmin/marking/finish/',
            event_params:
              '{flowId: this.$route.params.id, orderId: this.flowInfo.orderId}',
          },
          this.staParams,
        ),
      );
    },
    alertFinish(msg) {
      this.$alert(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: (action) => {
          if (action === 'confirm') {
            //结束打标
            this.finishPe();
          } else {
            this.$router.replace('/refresh');
          }
        },
      });
    },
  },
  filters: {},
};
</script>
<style lang="scss" scoped>
.avue-view {
  background: #ffffff;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}
</style>
